import { createStore } from "owa-satcheljs";
import type { AdContentSharingConsentState } from "./schema/AdContentSharingConsentState";

export const getAdContentSharingConsentStore: () => AdContentSharingConsentState = createStore<AdContentSharingConsentState>("adContentSharingConsentStore", {
    visibleSurface: undefined,
});
